import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-48 h-48 bg-white rounded-md flex justify-center items-center flex-col" }
const _hoisted_2 = { class: "text-h-primary-500 font-semibold mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onRecordStop && _ctx.onRecordStop(...args))),
      class: "flex justify-center items-center w-16 h-16 bg-h-info-100 rounded-full border-2 border-h-primary-500"
    }, [
      _createVNode(_component_v_icon, {
        name: "hi-solid-microphone",
        class: "text-primary-400 animate-pulse"
      })
    ]),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("labels.generic", {
          pt: "Gravando...",
          en: "Recording...",
        })) + ". ", 1)
  ]))
}